import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "img-panel" }
const _hoisted_2 = { class: "number-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Transporte = _resolveComponent("Transporte")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_ComisionesAuxiliosBonificaciones = _resolveComponent("ComisionesAuxiliosBonificaciones")!
  const _component_Prima = _resolveComponent("Prima")!
  const _component_Cesantias = _resolveComponent("Cesantias")!
  const _component_Compensaciones = _resolveComponent("Compensaciones")!
  const _component_Epctv = _resolveComponent("Epctv")!
  const _component_PagoTercerosAnticipos = _resolveComponent("PagoTercerosAnticipos")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SelectButton, {
      modelValue: $setup.selectButton,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectButton) = $event)),
      options: $setup.options,
      onClick: $setup.SelectedOption
    }, {
      option: _withCtx((props) => [
        _createVNode(_component_el_tooltip, {
          content: props.option.tooltip,
          placement: "bottom",
          "open-delay": "10"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(props.option.number), 1)
          ]),
          _: 2
        }, 1032, ["content"])
      ]),
      _: 1
    }, 8, ["modelValue", "options", "onClick"]),
    _createVNode(_component_TabView, {
      activeIndex: $setup.activePanel,
      "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => (($setup.activePanel) = $event)),
      class: "radio-tabview",
      scrollable: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Transporte, { nomina: $setup.scopeNomina }, null, 8, ["nomina"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_ComisionesAuxiliosBonificaciones, { nomina: $setup.scopeNomina }, null, 8, ["nomina"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Prima, { nomina: $setup.scopeNomina }, null, 8, ["nomina"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Cesantias, { nomina: $setup.scopeNomina }, null, 8, ["nomina"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Compensaciones, { nomina: $setup.scopeNomina }, null, 8, ["nomina"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Epctv, { nomina: $setup.scopeNomina }, null, 8, ["nomina"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          default: _withCtx(() => [
            _createVNode(_component_PagoTercerosAnticipos, { nomina: $setup.scopeNomina }, null, 8, ["nomina"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeIndex"])
  ]))
}